module.exports = __webpack_public_path__ + "img/img-5.35339221.jpg";